import { render, staticRenderFns } from "./CmfPickupStep1.vue?vue&type=template&id=0c0a2d22&scoped=true"
import script from "./CmfPickupStep1.vue?vue&type=script&lang=js"
export * from "./CmfPickupStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0a2d22",
  null
  
)

export default component.exports